<template>
    <div class="main-page-container">
        <AlertFoundActiveSession/>
        <PageHeader v-if="showHeaderActions" :title="$t('sideNavbarMenu.reporting.list.UsersNotOnSite')" className="d-flex align-items-center">
            <b-button @click="changeReportCriteria()" pill class="d-flex align-items-center 
            justify-content-center text-center  generate-users-btn "  variant="primary" size="sm" >{{ $t('common.updateCriteria')}}</b-button>
            <b-button @click="updateReportData()" pill class="d-flex align-items-center justify-content-center 
            text-center  update-users-btn "  variant="primary" size="sm" >{{ $t('common.updateData') }}</b-button>
        </PageHeader>
        <UsersNotOnSiteForm v-if="showUsersNotOnSiteForm && !isGenerating" @usersNotOnSiteSubmitForm="usersNotOnSiteAfterSubmitForm"/>
        <UsersNotOnSiteGrid v-if="showUsersNotOnSiteGrid" :data="gridData" :sitesIds = this.sitesIds @refreshGrid = "refreshGrid" />
        <UsersNotOnSiteLoader v-if="isGenerating" :loaderText='loaderText'/>
    </div>
</template>
  
<script>
    import { mapActions, mapGetters } from "vuex";
    import PageHeader from "../../../components/page-header.vue";
    import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
    import UsersNotOnSiteForm from "@/components/reports/usersNotOnSite/UsersNotOnSiteForm";
    import UsersNotOnSiteGrid from "@/components/reports/usersNotOnSite/UsersNotOnSiteGrid";
    import UsersNotOnSiteLoader from "@/components/reports/usersNotOnSite/UsersNotOnSiteLoader";
    import moment from "moment";

    export default {
        name: "usersNotOnSite",
        title: "Users not on site",
        components: {
            PageHeader,
            AlertFoundActiveSession,
            UsersNotOnSiteForm,
            UsersNotOnSiteGrid,
            UsersNotOnSiteLoader,
        },
        data() {
            return {
                title: "Users not on site",
                showHeader : false,
                showHeaderActions : false,
                showUsersNotOnSiteForm : false,
                showUsersNotOnSiteGrid : false,
                isGenerating: false,
                loaderText : this.$t('common.generateReport'),
                gridData : {
                    users : [],
                    reportDate : '',
                    sitesString : '',
                    regenerate : false,
                },
                sitesIds : [],
                userTypesIds : [],
            };
        },
        computed: {
            ...mapGetters("authfack", [ "currentEntity", "userDetails", ]),
            ...mapGetters("reports", [ "getUsersNotOnSite"]),
            ...mapGetters("i18N", ["getLanguage"]),
        },
        methods: {
            ...mapActions("sites", [ "fetchSites" ]),
            ...mapActions("reports", [ "fetchUsersNotOnSite" ]),
            getReportDate(date){
                console.log("date")
                console.log(date)
                let formattedDate;
                if(this.getLanguage == 'ar')
                    formattedDate = moment(new Date(date  + " UTC")).locale('ar_SA').format("DD/MM/YYYY - hh:mm A");
                else
                    formattedDate = moment(new Date(date  + " UTC")).format("DD/MM/YYYY - hh:mm A");  
                return formattedDate;
            },
            changeReportCriteria(){
                document.getElementById("preloader").style.display = "block";
                document.getElementById("status").style.display = "block";  
                this.showUsersNotOnSiteForm = true;
                this.showUsersNotOnSiteGrid = false;
                this.showHeader = true;
                this.showHeaderActions = false;
                this.isGenerating = false;
                document.getElementById("preloader").style.display = "none";
                document.getElementById("status").style.display = "none";  
            },
            updateReportData(){
                this.showUsersNotOnSiteGrid = false;
                this.loaderText = this.$t('common.updatingReport');
                this.isGenerating = true;
                this.showHeader = false;
                this.fetchUsersNotOnSite({
                    params : {
                        site_ids : this.sitesIds,
                        user_type_ids : this.userTypesIds,
                    }
                }).then((data)=>{
                    // console.log('data', data);
                    if(data){
                        this.showUsersNotOnSiteForm = false;
                        this.gridData.users = data.data.users;
                        this.gridData.reportDate = this.getReportDate(data.data.report_date);                        this.gridData.sitesString = data.data.sites_string;
                        this.gridData.regenerate = true;
                        this.sitesIds = data.data.siteIds;
                        this.userTypesIds = data.data.userTypeId;
                        this.showHeader = true;
                        this.showHeaderActions = true;
                        this.isGenerating = false;
                        this.showUsersNotOnSiteGrid = true;
                    }
                });
            },
            refreshGrid(){
                this.showUsersNotOnSiteGrid = false;
                this.showHeader = false;
                this.fetchUsersNotOnSite({
                    params : {
                        site_ids : this.sitesIds,
                        user_type_ids : this.userTypesIds,
                    }
                }).then((data)=>{
                    // console.log('data', data);
                    if(data){
                        this.showUsersNotOnSiteForm = false;
                        this.gridData.users = data.data.users;
                        this.gridData.reportDate = this.getReportDate(data.data.report_date);
                        this.gridData.sitesString = data.data.sites_string;
                        this.gridData.regenerate = true;
                        this.sitesIds = data.data.siteIds;
                        this.userTypesIds = data.data.userTypeId;
                        this.showHeader = true;
                        this.showHeaderActions = true;
                        this.showUsersNotOnSiteGrid = true;
                    }
                });
            },
            usersNotOnSiteAfterSubmitForm(data) {
                // console.log('data.sites',data.sites);
                // console.log('data.userTypes',data.userTypes);
                this.isGenerating = true;
                this.showHeader = false;
                this.loaderText = this.$t('common.generateReport');
                this.fetchUsersNotOnSite({
                    params : {
                        site_ids : data.sites,
                        user_type_ids : data.userTypes,
                    }
                }).then((data)=>{
                    // console.log('data', data);
                    if(data){
                        this.showUsersNotOnSiteForm = false;
                        this.gridData.users = data.data.users;
                        this.gridData.reportDate = this.getReportDate(data.data.report_date);
                        this.gridData.sitesString = data.data.sites_string;
                        this.gridData.regenerate = true;
                        this.sitesIds = data.data.siteIds;
                        this.userTypesIds = data.data.userTypeId;
                        this.showHeader = true;
                        this.showHeaderActions = true;
                        this.isGenerating = false;
                        this.showUsersNotOnSiteGrid = true;
                    }
                   
                });
            },
        },
        watch:{
            showUsersNotOnSiteForm(value){
                console.log('form', value);
            },
            showUsersNotOnSiteGrid(value){
                console.log('grid', value);
            },
            showHeaderActions(value){
                console.log('actions', value);
            },
        },
        beforeMount() {
            this.fetchUsersNotOnSite({
                params : {
                    user_id : this.userDetails.user_id,
                    entity_id : this.currentEntity.id,
                }
            }).then((data)=>{
                // console.log('data', data);
                if(Array.isArray(data.data) && !data.data.length){
                    this.showHeader = true;
                    this.showUsersNotOnSiteForm = true;
                }else if(data && data.data.siteIds.length && data.data.userTypeId.length && data.data.users){
                    this.gridData.users = data.data.users;
                    this.gridData.reportDate =this.getReportDate(data.data.report_date);
                    this.gridData.sitesString = data.data.sites_string;
                    this.sitesIds = data.data.siteIds;
                    this.userTypesIds = data.data.userTypeId;
                    this.showUsersNotOnSiteGrid = true;
                    this.showHeader = true;
                    this.showHeaderActions = true;
                }

            });
        },
    };
</script>
  <style lang="scss" scoped>
    button.btn.d-flex.align-items-center.justify-content-center.text-center.generate-users-btn.btn-primary.btn-sm.rounded-pill {
        margin-inline-start:40px;
        height:27px;
        width: 127px;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: #FFFFFF;
    }
    button.btn.d-flex.align-items-center.justify-content-center.text-center.update-users-btn.btn-primary.btn-sm.rounded-pill {
        margin-inline-start:24px;
        height:27px;
        width: 127px;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        color: #FFFFFF;
    }
</style>